import { Form, Checkbox } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_reportingpage_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const ReportingPage = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.reportingpage_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_reportingpage_form(changedValues));
    onValuesChange(formData);
  }, 300);
  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="vertical"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Form.Item
        valuePropName="checked"
        name="Review and IR / 12 Month Reporting page correctly updated."
      >
        <Checkbox value="Review and IR / 12 Month Reporting page correctly updated.">
          Review and IR / 12 Month Reporting page correctly updated.
        </Checkbox>
      </Form.Item>
    </Form>
  );
});
export default ReportingPage;
